<div class="modal-header">
	<h4 class="modal-title text-center" id="modal-title">Distribute Users for Load </h4>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<form name="distributeForm" (submit)="saveDistributeData(testCaseEndPointLoadTestConfigs)">
	<div class="modal-body" id="modal-body">
        <ngb-alert type="warning" [dismissible]="false">
            <i class="fas fa-info-circle"></i> Please distribute user properly and distribution should be within 100%
        </ngb-alert>
		<table class="table table-condensed">
			<thead>
				<tr>
					<th>Endpoint name</th>
					<th width="30%">User (in %)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let config of testCaseEndPointLoadTestConfigs">
					<td>{{config.testCaseEndPoint.endPointName}}</td>
					<td><input type="number" class="form-control form-control-sm" [(ngModel)]="config.distributedUserLoad" [ngModelOptions]="{standalone: true}" min="0"></td>
				</tr>
			</tbody>
		</table>
		<div class="modal-footer">
			<small class="text-danger">{{distributeError}}</small>
			<button type="submit" class="btn relay-btn save" id="distrib-save">Save</button>
		</div>
	</div>
</form>
